export function getFrameworkId(): string {
  return 'tailwind';
}
export { default as TailwindRenderer, default } from './TailwindRenderer.js';
